import { render, staticRenderFns } from "./hezhi1.vue?vue&type=template&id=bb64aacc&"
import script from "./hezhi1.vue?vue&type=script&lang=js&"
export * from "./hezhi1.vue?vue&type=script&lang=js&"
import style0 from "./hezhi1.vue?vue&type=style&index=0&id=bb64aacc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports